import {
  QueryClient,
  type QueryKey,
  useQueryClient,
} from '$lib/api/tanstack-query';

const invalidateQueries = async (
  queryClient: QueryClient,
  queryKeys: readonly QueryKey[]
) =>
  Promise.all(
    queryKeys.map(async (queryKey) =>
      queryClient.invalidateQueries({ queryKey })
    )
  );

const removeQueries = (
  queryClient: QueryClient,
  queryKeys: readonly QueryKey[]
) => queryKeys.map((queryKey) => queryClient.removeQueries({ queryKey }));

export interface QueryInvalidator {
  invalidateQueries: (queryKeys: readonly QueryKey[]) => Promise<void>;
  removeQueries: (queryKeys: readonly QueryKey[]) => void;
}

export const useQueryInvalidator = (): QueryInvalidator => {
  const queryClient = useQueryClient();

  return {
    invalidateQueries: async (queryKeys) => {
      await invalidateQueries(queryClient, queryKeys);
    },
    removeQueries: (queryKeys) => {
      removeQueries(queryClient, queryKeys);
    },
  };
};
